import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { IDoctor, IServ } from '../../../interfaces/record.interface';
import { Utils } from 'src/app/services/utils';
import { ConfigService } from 'src/app/services/application/config.service.';

@Component({
    selector: 'app-doctor-card',
    templateUrl: './doctor-card.component.html',
    styleUrls: ['./doctor-card.component.scss'],
})
export class DoctorCardComponent implements OnInit, OnDestroy {
    @Input() doctor!: IDoctor;
    @Input() isActive: boolean = false;
    @Input() openSelectStates: { [key: number]: boolean } = {};
    @Input() selectedSrvMap: { [key: number]: IServ } = {};
    @Input() searchStrSrv: { [doctorId: number]: any } = {};
    @Input() isMobile: boolean = false; // Получаем значение из родительского компонента

    @Output() serviceSelected = new EventEmitter<{
        service: IServ;
        doctor: IDoctor;
    }>();
    @Output() toggleSelectEvent = new EventEmitter<number>();
    @Output() searchSrvChanged = new EventEmitter<{
        searchText: string;
        doctorId: number;
    }>();
    @Output() openDocInfo = new EventEmitter<{
        doctor: IDoctor;
        event: Event;
    }>();
    @Output() openServDesc = new EventEmitter<{
        service: IServ;
        event: Event;
    }>();
    @Output() openMobileServiceListEvent = new EventEmitter<{
        doctor: IDoctor;
        event: Event;
    }>();
    @Output() pickDoc = new EventEmitter<{
        doctor: IDoctor;
    }>();

    showMobileServiceList: boolean = false;
    private mediaQuery: MediaQueryList | undefined;
    private mediaQueryListener:
        | ((this: MediaQueryList, ev: MediaQueryListEvent) => any)
        | null = null;

    constructor(private configS: ConfigService) {}

    ngOnInit(): void {
        // Если isMobile не передан извне, определяем его самостоятельно
        // if (this.isMobile === undefined) {
        this.initMobileCheck();
        // }
    }

    ngOnDestroy(): void {
        // Очистка слушателя при уничтожении компонента
        if (this.mediaQueryListener) {
            this.mediaQuery?.removeListener(this.mediaQueryListener);
        }
    }

    /**
     * Инициализирует проверку на мобильное устройство
     */
    private initMobileCheck(): void {
        // Создаем медиа-запрос для проверки ширины экрана
        this.mediaQuery = window.matchMedia('(max-width: 500px)');

        // Создаем слушатель изменений медиа-запроса
        this.mediaQueryListener = (e) => {
            this.isMobile = e.matches;
        };

        // Добавляем слушатель
        this.mediaQuery.addListener(this.mediaQueryListener);

        // Устанавливаем начальное значение
        this.isMobile = this.mediaQuery.matches;
    }

    /**
     * Открывает мобильный список услуг
     * @param event Событие клика
     */
    openMobileServiceList(event: Event): void {
        event.stopPropagation();
        if (this.doctor.srvlist && this.doctor.srvlist.length > 0) {
            this.showMobileServiceList = true;
            this.openMobileServiceListEvent.emit({
                doctor: this.doctor,
                event,
            });
        }
    }

    /**
     * Закрывает мобильный список услуг
     */
    closeMobileServiceList(): void {
        this.showMobileServiceList = false;
    }

    /**
     * Обрабатывает выбор услуги в мобильном списке
     * @param service Выбранная услуга
     */
    onMobileServiceSelected(service: IServ): void {
        this.selectService(service, this.doctor);
        this.closeMobileServiceList();
    }

    experienceText(exp: string): string {
        return Utils.experienceText(exp);
    }

    getFioDoc(doctor: IDoctor): string {
        if (!doctor || !doctor.l_name || !doctor.f_name) return '';
        return `${doctor.l_name} ${doctor.f_name} ${doctor.s_name || ''}`;
    }

    toggleSelect(doctorId: number) {
        this.toggleSelectEvent.emit(doctorId);
    }

    changeSearchSrv(searchText: string, doctorId: number) {
        this.searchSrvChanged.emit({ searchText, doctorId });
    }

    selectService(service: IServ, doctor: IDoctor) {
        this.serviceSelected.emit({ service, doctor });
    }

    openDocInfoModal(doctor: IDoctor, event: Event) {
        console.log(doctor);

        event.stopPropagation();
        this.openDocInfo.emit({ doctor, event });
    }

    openServDescModal(service: IServ, event: Event) {
        event.stopPropagation();
        this.openServDesc.emit({ service, event });
    }

    rcountText(count: number): string {
        if (!count) return 'Нет номерков';

        const lastDigit = count % 10;
        const lastTwoDigits = count % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return `Осталось ${count} номерков`;
        }

        switch (lastDigit) {
            case 1:
                return `Остался ${count} номерок`;
            case 2:
            case 3:
            case 4:
                return `Осталось ${count} номерка`;
            default:
                return `Осталось ${count} номерков`;
        }
    }
    getImgSrcDoc(id: number): string {
        return `${this.configS.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    getDocImgDefault(event: Event) {
        const elem = event.target as HTMLImageElement;
        elem.src = `${this.configS.getValue('hostBackend')}/img/doc/not.png`;
    }

    async onFilterChanged(event: any) {
        switch (event.typeEvent) {
            case 'srvPicked':
        }
        this.serviceSelected.emit({
            service: event,
            doctor: this.doctor,
        });

        this.showMobileServiceList = false;
    }

    showSrvHandler(event: any, doctor: IDoctor) {
        event.stopPropagation();
        this.serviceSelected.emit({
            service: event.data,
            doctor: this.doctor,
        });
        // this.selectedDoctor = doctor;
        // this.showSrv = true;

        // this.showMobileServiceList = true;
    }

    pickDoctorHandler(doctor: IDoctor) {
        this.pickDoc.emit({
            doctor: doctor,
        });
    }
}
